<template>
  <!-- custom pages -->
  <div class="mb-12" v-if="customPages.length != 0">
    <h2 class="text-565656 fsize18 border-b font-semibold pb-4 mb-8">
      Custom Pages
    </h2>

    <div
      v-for="(headings, index) in allheadingNames"
      :key="'headings -' + index"
      :class="{ 'px-2': headings.pagesID.length !== 0 }"
    >
      <div v-if="headings.pagesID.length > 0">
        <h2 class="text-565656 fsize16 font-semibold">
          {{ headings.headingName }}
        </h2>
        <div class="grid gap-4 grid-cols-3 mt-6 mb-8">
          <div
            class="cursor-pointer effecthover rounded-lg"
            v-for="(item, index) in customPages"
            :key="'item -' + index"
            @click="handleClick(item.route)"
          >
            <div class="flex items-center bg-lightf4f5f6 border-round p-3">
              <div class="flex gap-4 items-center w-10/12">
                <div>
                  <!-- v-if="item.image" -->
                  <img
                    :src="
                      item.image == 'undefined' || item.image == ''
                        ? 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained-product/Dash/projects/default_project.png'
                        : item.image
                    "
                    class="object-contain w-16 h-16 bg-ec rounded-lg"
                    alt="banh"
                  />
                </div>

                <div class="w-full">
                  <h3 class="col-4f fsize14 font-medium mb-0">
                    {{ item.title }}
                  </h3>
                </div>
              </div>
              <div class="w-2/12 flex justify-end cursor-pointer">
                <div>
                  <!-- <img
                    src="@/assets/images/aright.png"
                    class="w-35px rounded-full"
                  /> -->
                  <div
                    class="flex justify-center bg-light-secondary rounded-full items-center w-10 h-10"
                  >
                    <feather-icon
                      icon="ChevronRightIcon"
                      svgClasses="w-5 h-5"
                      class="text-secondary font-semibold flex"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      allheadingNames: [],
    };
  },
  props: {
    customPages: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleClick(name) {
      this.$router.push({ path: "coming" });
    },
    async getHeadingPages() {
      let payload = {
        projectName: this.selectedProject.projectName,
      };
      let data = await this.$store.dispatch(
        "agreement/getHeadingsPages",
        payload
      );
      this.allheadingNames = data.data;
    },
    // async getAdminPages() {
    //   // let tasklist = await this.$store.dispatch("builder/getTasklist", {
    //   //   projectName: this.selectedProject.projectName,
    //   // });
    //   let { data } = await this.$store.dispatch("AdminPages/GET");
    //   this.$emit(
    //     "customPages",
    //     this.customPages.length ? this.customPages : []
    //   );
    //   // this.cards = data.map((x) => {
    //   //   return {
    //   //     title: x.page,
    //   //     image: `${x.icon}`,
    //   //     route: x.hasOwnProperty("path") ? x.path : "",
    //   //   };
    //   // });
    //   // console.log(data);
    // },
  },

  mounted() {
    // this.getAdminPages();
    this.getHeadingPages();
    // let array = this.customPages.map((x) => x.title);
  },

  computed: {
    ...mapState("user", ["selectedProject"]),
    ...mapState("admin", ["userModules", "login", "allModules"]),
    // ...mapState("AdminPages", ["customPages"]),
  },
};
</script>
